import { render, staticRenderFns } from "./PackAntishazam.vue?vue&type=template&id=5392af9a&"
import script from "./PackAntishazam.vue?vue&type=script&lang=js&"
export * from "./PackAntishazam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports